import { useRef, useState, useEffect } from "react";
import { Link } from "@tanstack/react-router";
import { useAuth, useClerk, useUser, SignInButton } from "@clerk/react";
import { FaCircleUser } from "react-icons/fa6";
import styles from "../styles/components/TopBar.module.css";

export function NavMenu() {
  const { isLoaded, isSignedIn, userId } = useAuth();
  const { openUserProfile, openSignIn, signOut } = useClerk();
  const { user } = useUser();
  const role = (user?.publicMetadata as { role?: string } | undefined)?.role;
  const isAdmin = role === "admin" || role === "editor";
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!menuOpen) return;
    function onDown(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [menuOpen]);

  return (
    <div className={styles.right}>
      <div ref={menuRef} className={styles.navMenu}>
        <button
          type="button"
          className={styles.navMenuBtn}
          aria-label="Features menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          ☰
        </button>
        {menuOpen && (
          <div className={styles.navMenuPanel}>
            <span className={styles.navMenuLabel}>Account</span>
            {isSignedIn ? (
              <>
                <Link to="/profile" className={styles.navMenuLink} onClick={() => setMenuOpen(false)}>Profile</Link>
                <Link to="/my-rooms" className={styles.navMenuLink} onClick={() => setMenuOpen(false)}>My Rooms</Link>
              </>
            ) : (
              <>
                <button type="button" className={styles.navMenuBtn2} onClick={() => { setMenuOpen(false); openSignIn(); }}>Profile</button>
                <button type="button" className={styles.navMenuBtn2} onClick={() => { setMenuOpen(false); openSignIn(); }}>My Rooms</button>
              </>
            )}
            {isAdmin && (
              <>
                <div className={styles.navMenuDivider} />
                <span className={styles.navMenuLabel}>Admin</span>
                <Link to="/admin" className={styles.navMenuLink} onClick={() => setMenuOpen(false)}>Admin Dashboard</Link>
              </>
            )}
            {isSignedIn && (
              <>
                <div className={styles.navMenuDivider} />
                <button type="button" className={styles.navMenuBtn2} onClick={() => { setMenuOpen(false); openUserProfile(); }}>Manage Account</button>
                <button type="button" className={`${styles.navMenuBtn2} ${styles.navMenuSignOut}`} onClick={() => signOut()}>Sign out</button>
              </>
            )}
          </div>
        )}
      </div>
      {isLoaded && !isSignedIn && (
        <SignInButton mode="modal">
          <FaCircleUser size={28} color="var(--color-primary)" style={{ cursor: "pointer" }} />
        </SignInButton>
      )}
      {isLoaded && isSignedIn && user?.imageUrl && (
        <img
          src={user.imageUrl}
          alt={user.fullName ?? "Account"}
          className={styles.avatar}
          onClick={() => setMenuOpen((v) => !v)}
        />
      )}
    </div>
  );
}
